import { Pack } from 'src/app/shared/model/pack';
import { CompanyClient } from 'src/app/trip-calculator/models/companyClients';
import { ReductionObjective } from 'src/app/shared/model/reduction-objective';

export interface User {
  id?: string;
  firstName?: string;
  lastName?: string;
  emails: { email: string }[];
  phone?: string;
  role?: string;
  companyId?: string;
  addressId?: string;
  createdAt?: Date;
  lastLogin?: Date;
  isValidated?: boolean;
  preferredLanguage?: string;
  marketingOptOut?: boolean;
}

export interface CreateUserDTO {
  firstName?: string;
  lastName?: string;
  phone?: string;
  role?: string;
  companyId?: string;
  email: string;
  password?: string;
  preferredLanguage?: string;
  marketingOptOut?: boolean;
}

export interface EditUserDTO {
  firstName?: string;
  lastName?: string;
  phone?: string;
  role?: string;
  companyId: string;
  email: string;
  password?: string;
  preferredLanguage?: string;
  marketingOptOut?: boolean;
}

export interface UserFullInfo {
  id?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  role?: string;
  companyId: string;
  addressId?: string | null;
  createdAt?: string;
  lastLogin?: string | null;
  isValidated?: boolean;
  preferredLanguage?: string;
  marketingOptOut?: boolean;
  emails?: Email[];
  company?: Company;
}

export interface Email {
  email: string;
  id: string;
  isPrimary: boolean;
  isVerified: boolean;
  userId: string;
}

export interface Address {
  street: string | null;
  streetNumber: string | null;
  city: string | null;
  zipCode: string | null;
  country: string | null;
}

export enum Status {
  Active = 'active',
  Inactive = 'inactive',
}

export enum CompanySize {
  Micro = 'micro',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export interface Company {
  name?: string;
  vatNumber?: string;
  logoUrl?: string | null;
  packId?: string;
  /** Stable, random Greentripper-wide identifier for this company (distinct from `id`). */
  publicId?: string;
  pack: Pack;
  status?: Status;
  size?: CompanySize;
  calculationCount?: number;
  useApi?: boolean;
  useGoogleApi?: boolean;
  addressId?: string;
  id?: string;
  address?: {
    street?: string;
    streetNumber?: string;
    city?: string;
    zipCode?: string;
    country?: string;
  };
  companyClients?: CompanyClient[];
  users?: User[];
  _count?: {
    users: number;
    trips: number;
    salesLeads?: number;
  };
  lastConnection?: string;
  contribution?: number;
  averageEmissions?: number;

  hasContactedSales?: boolean;
  contactedSalesAt?: string;
  adminEmail?: string;
  discoveryStatus?: string;

  // Forum Mode fields
  isForumAccount?: boolean;

  // Project restriction
  hasRestrictedProjects?: boolean;

  // Reduction objectives
  reductionObjectives?: ReductionObjective[];

  // Reduction actions (reduction tips the company commits to)
  reductionActions?: string[];

  // SDG & climate actions
  selectedSdgs?: number[];
  customActions?: string[];
  selectedVulnerabilities?: number[];

  // Financial
  annualRevenue?: number;
}
export interface CreateCompanyDTO {
  name?: string;
  vatNumber?: string;
  logoUrl?: string | null;
  status?: Status;
  size?: CompanySize;
  calculationCount?: number;
  useApi?: boolean;
  useGoogleApi?: boolean;
  addressId?: string;
  id?: string;
  address?: {
    street?: string;
    streetNumber?: string;
    city?: string;
    zipCode?: string;
    country?: string;
  };
  companyClients?: CompanyClient[];
  users?: User[];
  _count?: {
    users: number;
    trips: number;
    salesLeads?: number;
  };
  lastConnection?: string;
  contribution?: number;
  averageEmissions?: number;
  // Discovery Mode fields
  hasContactedSales?: boolean;
  contactedSalesAt?: string;
  adminEmail?: string;
  discoveryStatus?: string;

  // Forum Mode fields
  isForumAccount?: boolean;

  // Project restriction
  hasRestrictedProjects?: boolean;
}
